module.exports = __webpack_public_path__ + "static/img/LxnGali.3f3ae52.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/card/LxnGali.jpg
// module id = xUSq
// module chunks = 1